/* Casa de Diciembre · Ficha de oferta (portada de The December Table, EE. UU.) (sections/cdd-bundle-offer.liquid)
   - Tarjetas de pack (radios fuera del <form>): copia la variante elegida al input[name=id]
     del formulario principal Y de la banda de cierre (cdd-product-cta), para que cualquier
     botón de la página añada lo que el cliente ha elegido.
   - Actualiza el precio de los botones («Añadir al carrito · X €»), la barra fija móvil y ?variant=.
   - Galería, línea de entrega, barra fija y «Añadido al carrito ✓» los hace cdd-product.js. */
(function () {
  if (window.__cddBundleOffer) return;
  window.__cddBundleOffer = true;

  function setBtnLabel(btn, label) {
    if (!btn) return;
    // Si cdd-product.js está mostrando «Añadido al carrito ✓», actualiza la etiqueta que va a restaurar.
    if (btn.dataset.cddLabel !== undefined) btn.dataset.cddLabel = label;
    else btn.textContent = label;
  }

  function init(root) {
    if (!root || root.dataset.boReady === '1') return;
    root.dataset.boReady = '1';
    var radios = root.querySelectorAll('.cdd-bo-card__input');
    if (!radios.length) return;
    var base = root.dataset.btnLabel || (window.cddI18n && window.cddI18n.addToCart) || 'Añadir al carrito';
    var sectionId = root.dataset.section;

    function apply(r, updateUrl) {
      var price = r.dataset.priceFmt || '';
      // Todos los formularios de producto de la página (principal + banda de cierre)
      document.querySelectorAll('product-form[data-cdd-form] form').forEach(function (form) {
        var input = form.querySelector('input[name="id"]');
        if (input) input.value = r.value;
        var btn = form.querySelector('button[name="add"]');
        if (!btn) return;
        if (btn.hasAttribute('data-bo-btn')) {
          setBtnLabel(btn, base + ' · ' + price);
        } else {
          var cur = btn.dataset.cddLabel !== undefined ? btn.dataset.cddLabel : btn.textContent;
          var head = cur.split(' · ')[0].trim() || base;
          setBtnLabel(btn, head + ' · ' + price);
        }
      });
      var sticky = document.querySelector('.cdd-sticky[data-section="' + sectionId + '"]');
      if (sticky) {
        var sp = sticky.querySelector('[data-cdd-sticky-price]');
        var sn = sticky.querySelector('[data-cdd-sticky-note]');
        if (sp) sp.textContent = price;
        if (sn) sn.textContent = r.dataset.title || sn.dataset.short || '';
      }
      radios.forEach(function (x) {
        var card = x.closest('[data-bo-card]');
        if (card) card.classList.toggle('is-checked', x === r);
      });
      if (updateUrl && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* noop */ }
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r, true); });
    });
    var checked = root.querySelector('.cdd-bo-card__input:checked') || radios[0];
    if (checked) { checked.checked = true; apply(checked, false); }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cdd-bundle]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Volver atrás (bfcache): re-sincroniza con el radio que restauró el navegador
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-cdd-bundle]').forEach(function (root) {
      var c = root.querySelector('.cdd-bo-card__input:checked');
      if (c) c.dispatchEvent(new Event('change'));
    });
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
